<template>
  <template v-if="dsComponentDetails.version === VersionOptions.LEGACY">
    <div
      v-if="showDelimiter"
      class="sb-tab__wrapper"
    >
      <div class="sb-tab__delimiter" />
      <div

        :class="classes"
        data-sb-automation="tab-container"
        @click.stop="handleSetActiveTab"
      >
        <!--
      @slot used for the content of the tab
      -->
        <slot />
      </div>
    </div>
    <div
      v-else
      :class="classes"
      data-sb-automation="tab-container"
      @click.stop="handleSetActiveTab"
    >
      <!--
    @slot used for the content of the tab
    -->
      <slot />
    </div>
  </template>
  <sb-tab-next
    v-else
    :tab="tab"
    :delimit="delimit"
    :disabled="disabled"
    s
  >
    <slot />
  </sb-tab-next>
</template>

<script>
import isEqual from 'lodash/isEqual';
import { versionedComponentsMixin } from '@src/mixins/versionedComponents';
import SbTabNext from '@src/components/Tabs/components/SbTabNext.vue';

export default {
  name: 'SbTab',
  components: {
    SbTabNext,
  },
  mixins: [versionedComponentsMixin],
  inject: ['sbTabs', 'setActiveTab'],
  props: {

    /**
     * Model of the tab that will be the `v-model` value of the SbTabs component when this tab is active.
     */
    tab: {
      default: null,
      type: [String, Number, Object],
    },

    /**
     * Flag used to apply a vertical separator to the left of this tab.
     */
    delimit: {
      type: Boolean,
      default: false,
    },
    /**
     * If the tab is disabled or not
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Style variation for use of tabs in different contexts.
     * `default, dropdown`
     * ** Dropdown is used by SbTabs when the screen size becomes small and tabs need to be moved into the dropdown. **
     */
    variation: {
      type: String,
      default: 'default',
      validator: (value) => {
        return value.match(/(default|dropdown)/);
      },
    },
  },
  computed: {
    classes() {
      if (this.disabled) return ['sb-tab-disabled'];
      let classes = ['sb-tab', `sb-tab--${this.variation}`];
      if (this.active) classes = classes.concat(['sb-tab--active', `sb-tab--active--${this.variation}`]);
      if (this.tab === 'more') classes.push('sb-tab__more');
      return classes;
    },
    active() {
      return this.tab !== null && isEqual(this.sbTabs.activeTab, this.tab);
    },
    showDelimiter() {
      return this.delimit && this.variation !== 'dropdown';
    },
  },
  methods: {
    handleSetActiveTab() {
      this.setActiveTab(this.tab);
    },
  },
};
</script>

<style lang='scss'>
@import '@src/components/Tabs/style/sb-tab.scss';
</style>
